import { skipToken, useQuery } from '@tanstack/react-query';
import { getV1BillingSummary } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { BillingSummary } from '~hooks/useBilling/models';
import connection from '~services/connectionModule';

export default function useBillingSummaryQuery(companyId: string) {
  const { data, isError, isPending, refetch } = useQuery({
    queryKey: ['billingSummary', companyId],
    queryFn: companyId
      ? async ({ signal }) => {
          try {
            const response = await getV1BillingSummary({
              path: { 'company-id': companyId },
              signal,
            });
            const summary = response.data.data;

            return summary ? BillingSummary.parse(summary) : null;
          } catch (error) {
            connection.handleRequestError(
              error,
              t('error_messages.billing.failed_to_fetch_summary'),
            );
            throw error;
          }
        }
      : skipToken,
  });

  return { isError, isPending, refetch, summary: data ?? null };
}
